import React, { useState, useEffect, useContext } from "react";
import "./CurrencySettings.css";
import { LanguageContext } from "../context/LanguageContext";

const CurrencySettings = ({ objectId, onCurrencyChange }) => {
  const [currency, setCurrency] = useState("");
  const [availableCurrencies, setAvailableCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [objectName, setObjectName] = useState("");

  const { language, texts } = useContext(LanguageContext);

  useEffect(() => {
    const langParam = `?lang=${language}`;
    const token = localStorage.getItem("authToken");

    // -----------------------------
    // 1) Währungen laden (multilingual)
    // -----------------------------
    const fetchCurrencies = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/currencies${langParam}`
        );

        if (!response.ok)
          throw new Error(texts.currency.errorLoadingCurrencies);

        const data = await response.json();
        setAvailableCurrencies(data);
      } catch (error) {
        console.error("Fehler beim Abrufen der Währungen:", error);
      }
    };

    // -----------------------------
    // 2) Objektwährung laden
    // -----------------------------
    const fetchObjectCurrency = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/object/${objectId}/currency`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!response.ok)
          throw new Error(texts.currency.errorLoadingObjectCurrency);

        const data = await response.json();
        setCurrency(data.currency);
      } catch (error) {
        console.error("Fehler beim Abrufen der Objektwährung:", error);
      }
    };

    // -----------------------------
    // 3) Objektname laden 
    // -----------------------------
    const fetchObjectName = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/objects`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!response.ok) throw new Error("Fehler beim Laden der Objekte");

        const objects = await response.json();
        const matched = objects.find((o) => String(o.id) === String(objectId));

        setObjectName(matched?.name || `${texts.additionalCosts.object} ${objectId}`);
      } catch (error) {
        console.error("Fehler beim Laden des Objektnamens:", error);
        setObjectName(`${texts.additionalCosts.object} ${objectId}`);
      }
    };


    fetchCurrencies();
    fetchObjectCurrency();
    fetchObjectName();
  }, [objectId, language, texts]);

  // -----------------------------
  // 4) Speichern
  // -----------------------------
  const handleSaveCurrency = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/object/${objectId}/currency`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ currency }),
        }
      );

      if (!response.ok)
        throw new Error(texts.currency.errorSaving);

      alert(texts.currency.saved);

      if (onCurrencyChange) onCurrencyChange();
    } catch (error) {
      console.error("Fehler beim Speichern:", error);
      alert(texts.currency.errorSaving);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="currency-container">
      <h2>
        {texts.currency.title} {objectName}
      </h2>

      <select
        className="currency-select"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
      >
        <option value="">{texts.currency.select}</option>
        {availableCurrencies.map((cur) => (
          <option key={cur.code} value={cur.code}>
            {cur.name} ({cur.code})
          </option>
        ))}
      </select>

      <button
        className="currency-save-button"
        onClick={handleSaveCurrency}
        disabled={loading || !currency}
      >
        {loading ? texts.currency.saving : texts.currency.save}
      </button>
    </div>
  );
};

export default CurrencySettings;
